module.exports = __webpack_public_path__ + "static/media/icon_target.9813e390.png";